import React from 'react'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import FormSchemaValidations from './schema-validations'
import FormBase from './form-base'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { setOpenModal, addUserAction, checkIfUserExists } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { addClient } from '../thunks'

const Create = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector(state => state.customerMaster)
  const { personTypes, taxpayerTypes } = useSelector(state => state.invoiceIssuance)

  // Los id de catálogo cambian entre ambientes: se resuelven contra el
  // backend en vez de hardcodearlos
  const idTipoPersona = (codigo) => Number(personTypes?.find?.(item => item.value === codigo)?.id) || null

  // "Tipo de contribuyente" solo se muestra para CCF (03); para el resto el
  // valor sale del default. Solo se acepta lo que exista en CAT-091: un
  // cliente antiguo puede traer guardado un país, y eso debe caer a "Otro"
  const idContribuyente = (seleccion) => {
    const catalogo = taxpayerTypes || []
    const enCatalogo = catalogo.find(item => item.value === seleccion?.value)
    const otro = catalogo.find(item => item.value === '04')
    return Number(enCatalogo?.id ?? otro?.id) || null
  }

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      type_of_entity: '',
      NIT: '',
      NRC: '',
      DUI:'',
      society: '',
      type_of_establishment: '',
      address: '',
      phone: '',
      economic_activity: '',
      main_admin_name: '',
      main_admin_email: ''
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(FormSchemaValidations)
  })

  const onSubmit = async (data) => {
    if (checkIfUserExists(data.DUI, data.NIT)) {
      toast.error("El usuario con este DUI o NIT ya existe");
      return;
    }

    const createUser = await dispatch(addClient({...data,
      municipalityId: Number(data.municipality?.id) || 528,
      departmentId: Number(data.department?.id) || 15,
      districtId: Number(data.district?.id) || null,
      typeEntityId: idTipoPersona(data.typeEntity.value === "N" ? '1' : '2'),
      largeConsumerId: idContribuyente(data?.largeConsumer),
      dteClientTypeId: Number(data.dteType?.id),
      clientCode: null,
      dteTypeId: Number(data?.dteType?.id),
      company: data.receiverName,
      economicActivityId: Number(data.economicActivity.id),
      codeTypeId: null,
      country: data.country ? data.country.id : null
    }))

    if (createUser?.payload?.error) {
      toast.error("Error al crear usuario")
      return
    }
    toast.success("Usuario Creado")
    handleClose()
  }

  const handleClose = () => {
    dispatch(setOpenModal({ type: 'create', open: false }))
    reset()
  }

  return (
    <Modal
      isOpen={modal.create.open}
      toggle={ handleClose }
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader className="bg-transparent" toggle={ handleClose }>
        
      </ModalHeader>

      <FormProvider {...{ handleSubmit, control, reset, setValue, formState: { errors } }} >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
              <div style={{display:"flex", justifyContent: "center"}}>
                <h1>Crear Cliente</h1>
              </div>
            <FormBase />
            <div>
              <p>Campos obligatorios (*)</p>
            </div>
          </ModalBody>

          <ModalFooter className={'d-flex justify-content-center'}>
            
            <Button color="primary" type="submit">
              Guardar
            </Button>
            <Button
              type="reset"
              color="secondary"
              outline
              onClick={() => handleClose(false)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

export default Create
